import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

interface ListItem {
  id: number;
  product_id: number;
  product_name: string;
  quantity: number;
}

const ListDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [list, setList] = useState<any>(null);
  const [items, setItems] = useState<ListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [removing, setRemoving] = useState<number | null>(null);

  useEffect(() => {
    api.get(`/lists/${id}`)
      .then(res => {
        setList(res.data);
        setItems(res.data.items || []);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const removeItem = async (itemId: number) => {
    setRemoving(itemId);
    try {
      await api.delete(`/lists/${id}/items/${itemId}`);
      setItems(prev => prev.filter(i => i.id !== itemId));
    } catch {
      alert('Σφάλμα κατά την αφαίρεση.');
    } finally {
      setRemoving(null);
    }
  };

  if (loading) return <div style={S.center}>Φόρτωση...</div>;
  if (!list) return <div style={S.center}>Η λίστα δεν βρέθηκε.</div>;

  return (
    <div style={S.page}>
      <button onClick={() => navigate('/lists')} style={S.back}>← Πίσω στις λίστες</button>

      <div style={S.header}>
        <div>
          <h1 style={S.title}>{list.name}</h1>
          <p style={S.sub}>{items.length} προϊόντα</p>
        </div>
        <div style={S.headerBtns}>
          <button onClick={() => navigate(`/products`)} style={S.addBtn}>
            + Προσθήκη προϊόντος
          </button>
          {items.length > 0 && (
            <button onClick={() => navigate(`/lists/${id}/optimize`)} style={S.optimizeBtn}>
              💡 Σύγκριση
            </button>
          )}
        </div>
      </div>

      {items.length === 0 ? (
        <div style={S.empty}>
          <p>Η λίστα είναι άδεια.</p>
          <button onClick={() => navigate('/products')} style={S.addBtn}>
            + Αναζήτηση προϊόντων
          </button>
        </div>
      ) : (
        <div style={S.listBox}>
          {items.map((item, i) => (
            <div key={item.id} style={{ ...S.row, background: i % 2 === 0 ? '#F8FBFD' : 'white' }}>
              <div style={S.rowLeft}>
                <span style={S.productName}>{item.product_name}</span>
                <span style={S.qty}>×{item.quantity}</span>
              </div>
              <button
                onClick={() => removeItem(item.id)}
                disabled={removing === item.id}
                style={S.removeBtn}
                title="Αφαίρεση"
              >
                {removing === item.id ? '...' : '−'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const S: Record<string, React.CSSProperties> = {
  page: { maxWidth: 700, margin: '0 auto', padding: '24px 16px', fontFamily: 'Arial, sans-serif' },
  center: { textAlign: 'center', marginTop: 80, color: '#888' },
  back: { background: 'none', border: 'none', color: '#2952CC', cursor: 'pointer', fontSize: 14, marginBottom: 16, padding: 0 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24, flexWrap: 'wrap', gap: 12 },
  title: { color: '#2952CC', fontSize: 22, fontWeight: 700, margin: 0 },
  sub: { color: '#888', fontSize: 13, margin: '4px 0 0' },
  headerBtns: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  addBtn: { padding: '9px 18px', background: '#2952CC', color: 'white', border: 'none', borderRadius: 7, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  optimizeBtn: { padding: '9px 18px', background: '#EAFAF1', color: '#27AE60', border: '1.5px solid #A9DFBF', borderRadius: 7, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  empty: { textAlign: 'center', marginTop: 48, color: '#888' },
  listBox: { background: 'white', borderRadius: 10, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.07)' },
  row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #F0F4F8' },
  rowLeft: { display: 'flex', alignItems: 'center', gap: 10, flex: 1 },
  productName: { fontSize: 14, color: '#2952CC', fontWeight: 500 },
  qty: { fontSize: 13, color: '#888', background: '#EAF0FF', borderRadius: 4, padding: '2px 7px' },
  removeBtn: { width: 30, height: 30, borderRadius: '50%', border: '1.5px solid #FADBD8', background: '#FEF9F9', color: '#E74C3C', fontSize: 18, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
};

export default ListDetailPage;
